<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Internal User</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Internal User Password</b>
      <b-row class="mt-4">
        <b-col md="6" :class="this.$route.params.redirect == 'InternalUser' ?'d-none':''">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Current Password"
            label-for="input-1"
          >
            <input
              v-model="current_password"
              v-validate="'required'"
              name="current_password"
              type="password"
              class="form-control"
              placeholder="Enter a Password"
              ref="password"
            />
            <b-form-invalid-feedback
              id="input-current_password-feedback"
            >{{ veeErrors.first('current_password') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6" :class="this.$route.params.redirect == 'InternalUser' ?'':'d-none'">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="ID"
            label-for="input-1"
          >
            <input v-model="items.id" name="id" type="text" class="form-control" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6" :class="this.$route.params.redirect == 'InternalUser' ?'':'d-none'">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Username"
            label-for="input-1"
          >
            <input
              v-model="items.username"
              name="username"
              type="text"
              class="form-control"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Password"
            label-for="input-1"
          >
            <input
              v-model="password"
              v-validate="'required'"
              name="password"
              type="password"
              class="form-control"
              placeholder="Enter a New Password"
              ref="password"
            />
            <b-form-invalid-feedback id="input-password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Confirm Password"
            label-for="input-1"
          >
            <input
              @input="IsRepassword = true"
              v-model="retype_password"
              v-validate="'required|confirmed:password'"
              name="re_password"
              type="password"
              class="form-control"
              placeholder="Enter a Confirm Password"
            />
            <b-form-invalid-feedback
              id="input-re_password-feedback"
            >{{ veeErrors.first('re_password') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="veeErrors.any() || !isCompleted || loading"
            @click="put()"
            class="mr-3"
            size="lg"
          >
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: this.$route.params.redirect}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      current_password: "",
      password: "",
      retype_password: "",
      items: []
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "internalUserModule/getInternalUser",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.internalUserModule.internal_user_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    put() {
      this.loading = true;
      const formData = new FormData();
      if (this.$route.params.redirect == "InternalUser") {
        formData.append("user_id", this.$route.params.id);
        formData.append("password", this.password);
        this.$store
          .dispatch("internalUserModule/putChangePasswordOther", {
            id: this.$route.params.id,
            formData
          })
          .then(response => {
            this.loading = false;
            this.$router.push({ name: this.$route.params.redirect });
            this.$swal({
              type: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500
            });
            console.log(response);
          })
          .catch(error => {
            this.loading = false;
            this.serverError = error.response.data;
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            console.log(error);
          });
      } else {
        formData.append("current_password", this.current_password);
        formData.append("password", this.password);
        formData.append("retype_password", this.retype_password);
        this.$store
          .dispatch("internalUserModule/putChangePassword", {
            id: this.$route.params.id,
            formData
          })
          .then(response => {
            this.loading = false;
            this.$router.push({ name: this.$route.params.redirect });
            this.$swal({
              type: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500
            });
            console.log(response);
          })
          .catch(error => {
            this.loading = false;
            this.serverError = error.response.data;
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            console.log(error);
          });
      }
    }
  },
  computed: {
    isCompleted() {
      return (
        this.items.nim &&
        this.items.username &&
        this.items.role &&
        this.items.fullname &&
        this.items.email &&
        this.items.phone_number &&
        this.items.address
      );
    }
  }
};
</script>

<style>
</style>
